module.exports = __webpack_public_path__ + "img/icon-copy.eb8c8609.svg";